'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

interface BreadcrumbItem {
  label: string;
  path: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
  className?: string;
}

const Breadcrumb = ({ items, className = '' }: BreadcrumbProps) => {
  const pathname = usePathname();

  const generateBreadcrumbs = (): BreadcrumbItem[] => {
    if (items && items.length > 0) {
      return items;
    }

    const pathSegments = pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [
      { label: 'Home', path: '/product-catalog' }
    ];

    const pathMap: Record<string, string> = {
      'product-catalog': 'Products',
      'product-details': 'Product Details',
      'shopping-cart': 'Shopping Cart',
      'order-confirmation': 'Order Confirmation',
      'account': 'Account',
      'support': 'Support',
    };

    let currentPath = '';
    pathSegments.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = pathMap[segment] || segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
      breadcrumbs.push({ label, path: currentPath });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <nav data-component-id="src/components/common/Breadcrumb.tsx:56:4" data-component-path="src/components/common/Breadcrumb.tsx" data-component-line="56" data-component-end-line="89" data-component-file="Breadcrumb.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%7D" 
      aria-label="Breadcrumb" 
      className={`flex items-center space-x-2 text-sm ${className}`}
    >
      {breadcrumbs.map((item, index) => {
        const isLast = index === breadcrumbs.length - 1;
        const isFirst = index === 0;

        return (
          <div data-component-id="src/components/common/Breadcrumb.tsx:65:10" data-component-path="src/components/common/Breadcrumb.tsx" data-component-line="65" data-component-end-line="86" data-component-file="Breadcrumb.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20space-x-2%22%7D" key={item.path} className="flex items-center space-x-2">
            {!isFirst && (
              <Icon data-component-id="src/components/common/Breadcrumb.tsx:67:14" data-component-path="src/components/common/Breadcrumb.tsx" data-component-line="67" data-component-end-line="71" data-component-file="Breadcrumb.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChevronRightIcon%22%2C%22className%22%3A%22text-muted-foreground%20flex-shrink-0%22%7D" 
                name="ChevronRightIcon" 
                size={16} 
                className="text-muted-foreground flex-shrink-0" 
              />
            )}
            {isLast ? (
              <span data-component-id="src/components/common/Breadcrumb.tsx:74:14" data-component-path="src/components/common/Breadcrumb.tsx" data-component-line="74" data-component-end-line="76" data-component-file="Breadcrumb.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-caption%20font-medium%20text-foreground%20truncate%20max-w-%5B200px%5D%20sm%3Amax-w-none%22%7D" className="font-caption font-medium text-foreground truncate max-w-[200px] sm:max-w-none">
                {item.label}
              </span>
            ) : (
              <Link data-component-id="src/components/common/Breadcrumb.tsx:78:14" data-component-path="src/components/common/Breadcrumb.tsx" data-component-line="78" data-component-end-line="84" data-component-file="Breadcrumb.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22font-caption%20font-normal%20text-muted-foreground%20hover%3Atext-primary%20%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20transition-smooth%20truncate%20max-w-%5B150px%5D%20sm%3Amax-w-none%22%7D"
                href={item.path}
                className="font-caption font-normal text-muted-foreground hover:text-primary 
                         transition-smooth truncate max-w-[150px] sm:max-w-none"
              >
                {item.label}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;